import axios from 'axios';
import apiUrl from '../constants';

export function getshippingidDetails(input, token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'fetchShipmentDetail',
        data: input,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}

export function MarkNTSShipmentService(input, token){
    return axios({
            method: 'post',
            url: apiUrl.api_url + 'addNTStoInvestigation',
            data: input,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
}

export function MarkNTSBagService(input, token){
    return axios({
            method: 'post',
            url: apiUrl.api_url + 'addNTSBagtoInvestigation',
            data: input,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
}
export function ntsRoleConditoins(role,description)
{
  let data = {}
  if(role == 'cotteam'){
      return data = {
        Subreasons:'Process TAT breach',
        Comments :`COT Team:${description}`,
        Sourcetype:'COT Team'
     }
  }
  if(role == 'ntspilot'){
   return data = {
    Subreasons:'Post Manifest Inscan',
    Comments :`Opration Team:${description}`,
    Sourcetype:'Operations Team'
     }
    }
  }
 
  export function sourceTypeList() {
    let sourceTypeList= [{
             label: 'COT Team',
              }, {
                label: 'Operations Team',
              }]
    return sourceTypeList;
  }
  export function SubReasonsList() {
    let SubReasonsList =[{
      label: "Process TAT breach",
    }, {
      label: "Post Manifest Inscan",
    }]
    return SubReasonsList;
  }

export function getAWBDetailsFromBag(input, token){
  return axios({
    method: 'post',
    url: apiUrl.api_url + 'fetchBagShipmentDetails',
    data: input,
    headers: {
        'Authorization': 'Bearer ' + token
    }
  });
}


// WEBPACK FOOTER //
// ./src/services/ntsActions.js